export const constants = {
    resultsPerPage: 12
};
